import IdentificationSection from './sections/IdentificationSection';
import NameSection from './sections/NameSection';
import ContactSection from './sections/ContactSection';
import LicenseSection from './sections/LicenseSection';
import AdditionalInfoSection from './sections/AdditionalInfoSection';
import FeedbackSection from './sections/FeedbackSection';
import VehicleBasicSection from './sections/VehicleBasicSection';
import VehicleRegistrationSection from './sections/VehicleRegistrationSection';
import VehicleSoatSection from './sections/VehicleSoatSection';
import StepButtons from './form/StepButtons';
import AditionalVehicleInfoSection from './sections/AditionalVehicleInfoSection';

export default function VinculacionForm({
    step,
    data,
    formData,
    showMore,
    errors,
    options,
    onToggleShowMore,
    onBack,
    onContinue,
    onChange
}) {
    return (
        <>
            {/* Paso 1: Propietario */}
            {step === 1 && (
                <>
                    <IdentificationSection
                        data={data}
                        generos={options.generos}
                        tiposDocumento={options.tiposDocumento}
                        naturalezas={options.naturalezas}
                        paises={options.paises}
                        municipios={options.municipios}
                        onChange={onChange}
                        errors={errors}
                    />
                    <NameSection data={data} onChange={onChange} errors={errors} />
                    <ContactSection        
                        data={data}
                        paises={options.paises}
                        municipios={options.municipios} 
                        onChange={onChange} 
                        errors={errors} 
                    />
                    <div className={`collapsible ${showMore ? 'expanded' : ''}`}>
                        <AdditionalInfoSection 
                            data={data} 
                            municipios={options.municipios} 
                            onChange={onChange} 
                            errors={errors} 
                        />
                    </div>
                </>
            )}

            {/* Paso 2: Tenedor */}
            {step === 2 && (
                <>
                    <IdentificationSection
                        data={data}
                        generos={options.generos}
                        tiposDocumento={options.tiposDocumento}
                        naturalezas={options.naturalezas}
                        paises={options.paises}
                        municipios={options.municipios}
                        onChange={onChange}
                        errors={errors}
                    />
                    <NameSection data={data} onChange={onChange} errors={errors} />
                    <ContactSection        
                        data={data}
                        paises={options.paises}
                        municipios={options.municipios} 
                        onChange={onChange} 
                        errors={errors} 
                    />
                    <div className={`collapsible ${showMore ? 'expanded' : ''}`}>
                        <AdditionalInfoSection 
                            data={data} 
                            municipios={options.municipios} 
                            onChange={onChange} 
                            errors={errors} 
                        />
                    </div>
                </>
            )}

            {/* Paso 3: Conductor */}
            {step === 3 && (
                <>
                    <IdentificationSection
                        data={data}
                        generos={options.generos}
                        tiposDocumento={options.tiposDocumento}
                        naturalezas={options.naturalezas}
                        paises={options.paises}
                        municipios={options.municipios}
                        onChange={onChange}
                        errors={errors}
                    />
                    <LicenseSection        
                        data={data} 
                        licencias={options.licencias}
                        onChange={onChange} 
                        errors={errors} 
                    />
                    <NameSection data={data} onChange={onChange} errors={errors} />
                    <ContactSection        
                        data={data}
                        paises={options.paises}
                        municipios={options.municipios} 
                        onChange={onChange} 
                        errors={errors} 
                    />

                    <div className={`collapsible ${showMore ? 'expanded' : ''}`}>
                        <AdditionalInfoSection 
                            data={data} 
                            municipios={options.municipios} 
                            onChange={onChange} 
                            errors={errors} 
                        />
                    </div>
                </>
            )}

            {/* Paso 4: Vehículo */}
            {step === 4 && (
                <>
                    <VehicleBasicSection        
                        data={data} 
                        tiposVehiculos={options.tiposVehiculos}
                        marcas={options.marcas}
                        lineas={options.lineas}
                        combustibles={options.combustibles}
                        carrocerias={options.carrocerias}
                        configuraciones={options.configuraciones}
                        onChange={onChange} 
                        errors={errors} 
                    />
                    <VehicleRegistrationSection 
                        data={data} 
                        ciudadOrganismo={options.municipios}
                        onChange={onChange} 
                        errors={errors} 
                    />
                    <VehicleSoatSection         
                        data={data} 
                        empresasSeguros={options.empresasSeguros}
                        onChange={onChange} 
                        errors={errors} 
                    />
                    <FeedbackSection
                        propietario={formData[1]}
                        tenedor={formData[2]}
                        conductor={formData[3]}
                        vehiculo={data}
                    />
                    <div className={`collapsible ${showMore ? 'expanded' : ''}`}>
                        <AditionalVehicleInfoSection
                            data={data} 
                            onChange={onChange} 
                            errors={errors} 
                        />
                    </div>
                </>
            )}

            {/* Botones */}
            <StepButtons
                step={step}
                showMore={showMore}
                onToggleShowMore={onToggleShowMore}
                onBack={onBack}
                onContinue={onContinue}
                isFinal={step === 4}
            />
        </>
    );
}